// config
import * as http from 'utils/http';
import config from 'config';
// utils

const getShippers = async ({ search }) => {
  search = search.replace(/-/g, '');
  const data = await http.get(
    `${config.API_URL}mercury/shippers/?search=${search}&page_size=20&ordering=company_name`
  );
  return data;
};

export default getShippers;
